var React = require('react');

class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    // Data loading moved to appLoader.jsx to prevent duplicate API calls
    // when multiple components extending BaseComponent mount
  }

  render() {
    return <div>base component</div>;
  }
}

module.exports = BaseComponent;
